import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _regeneratorRuntime from "@babel/runtime/helpers/esm/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// import jwt from 'jsonwebtoken'
import { decode } from '@yuanfudao/metis-jwt';
import Cookie from 'js-cookie';
import qs from 'qs';
import { parse as getCookieDomainFromUrl } from 'tldts';
import { CODE_LOGIN, ERROR_CODE, IDENTITY_TYPES, PLATFORM, REFRESH_URL, USER_LOGIN_TYPE } from '../constants/login';
import { designationLogin, designationStudentLogin, getLoginUrls, logOutService, phonePasswordLogin, refreshCodeToken, verifyCodeLogin, getUserTenants, openLogin, flyingLogin, openLoginV2, unlockStudentAccount, createSsoTransferCode, exchangeSsoCodeForToken } from '../service/login';
import { getUrlPath, getUrlQuery } from './common';
import config from '../config';
import { delaySetLocalStorage, emitter, storageTidKey, storageTidKeyNew, storageTidKeyOld } from './storage';
var refreshing = false;
var refreshingPromise = Promise.resolve(true);
// 这些path，不需要跳转登录
var notGoToLoginPath = ['/embed/reset-password', '/login', '/login/', '/login/bind', '/designation-login', '/designation-student-login', '/token-login', '/open-login', '/nydus', '/nydus-v2'];
// 如果 redirectUrl 的地址包含这些path，则不跳转，转而跳转默认的地址
// const notToRedirectPath = ['/embed/403', '/embed/choose', '/embed/reset-password', '/login', '/login/', '/login/bind', '/designation-login', '/designation-student-login', '/token-login', '/open-login', '/nydus']
// 如果当前path是以下，那么根据当前URL获取 ?redirectUrl=xxx 将返回当前页面跟路径
var notGetSearchPath = ['/embed/403', '/embed/choose', '/login', '/login/', '/login/bind', '/designation-login', '/designation-student-login', '/token-login', '/embed/reset-password', '/open-login', '/nydus', '/nydus-v2'];
// 不需要登录也可以访问的页面
export var loginWhiteList = ['/embed/reset-password', '/login/bind', '/open-login', '/nydus', '/nydus-v2'];
// 需要登录，但登录之后不会自动跳走的页面
export var jumpWhiteList = ['/embed/account-info', '/embed/403', '/embed/choose', '/embed/personal-data'];
var curPlatform = PLATFORM.WEB;
// const fortyEightHours = 48 * 60 * 60 * 1000
var towMinutes = 120000;
var SSO_TRANSFER_CODE_QUERY_KEY = 'ssoTransferCode';
var SSO_QUERY_KEYS = [SSO_TRANSFER_CODE_QUERY_KEY];
var rtExpiredOffset = 0;
export function setRtExpiredOffset(offset) {
  rtExpiredOffset = offset;
}
var atExpiredOffset = towMinutes;
export function setAtExpiredOffset(offset) {
  atExpiredOffset = offset;
}
export function setPlatForm(p) {
  curPlatform = p;
}
export function getStorage(key) {
  if (curPlatform === PLATFORM.WEB) {
    return Cookie.get(key);
  }
  return localStorage.getItem(key);
}
export function removeStorage(key, options) {
  if (curPlatform === PLATFORM.WEB) {
    return Cookie.remove(key, options);
  }
  return localStorage.removeItem(key);
}
export function setStorage(key, value, options) {
  if (curPlatform === PLATFORM.WEB) {
    return Cookie.set(key, value, options);
  }
  return localStorage.setItem(key, value);
}
export function getCookieDomain(url) {
  return ".".concat(getCookieDomainFromUrl(url || window.location.href).domain);
  // return `.${window.location.hostname.split('.').slice(-2).join('.')}`
}

var customGoNoPermission;
export function goNoPermission() {
  if (customGoNoPermission && customGoNoPermission instanceof Function) {
    customGoNoPermission();
    return;
  }
  var search = getSearch();
  window.location.replace(config.noPermissionUrl + search);
  // window.location.href = config.noPermissionUrl + search
}

export function replaceGoNoPermission(fn) {
  customGoNoPermission = fn;
}
export function getDecodedToken() {
  var token;
  try {
    token = decode(getAccessToken());
  } catch (e) {
    console.warn(e);
    token = null;
  }
  return token;
}
// accessToken有效期
export function getAccessTokenTermOfValidity() {
  try {
    var token = getDecodedToken();
    if (token) {
      return token.exp * 1000 - Number(token.iat) * 1000;
    }
    return 0;
  } catch (e) {
    console.warn(e);
    return 0;
  }
}
export function getAccessToken() {
  return getStorage(CODE_LOGIN.ACCESS_TOKEN);
}
export function getRefreshToken() {
  return getStorage(CODE_LOGIN.REFRESH_TOKEN);
}
function getQueryValue(value) {
  if (Array.isArray(value)) {
    return value[0] ? String(value[0]) : undefined;
  }
  return value ? String(value) : undefined;
}
function setQueryParam(query, key, value) {
  if (value) {
    query[key] = value;
  }
}
function removeQueryParams(query, keys) {
  keys.forEach(function (key) {
    delete query[key];
  });
}
function removeQueryFromUrl(url, keys) {
  var queryIndex = url.indexOf('?');
  if (queryIndex === -1) {
    return url;
  }
  var baseUrl = url.slice(0, queryIndex);
  var query = qs.parse(url.slice(queryIndex + 1));
  removeQueryParams(query, keys);
  var search = qs.stringify(query);
  return "".concat(baseUrl).concat(search ? "?".concat(search) : '');
}
function appendQueryToHashUrl(url, params) {
  var hashIndex = url.indexOf('#');
  if (hashIndex === -1) {
    var _queryIndex = url.indexOf('?');
    var _baseUrl = _queryIndex === -1 ? url : url.slice(0, _queryIndex);
    var _query = qs.parse(_queryIndex === -1 ? '' : url.slice(_queryIndex + 1));
    Object.keys(params).forEach(function (key) {
      return setQueryParam(_query, key, params[key]);
    });
    var _search = qs.stringify(_query);
    return "".concat(_baseUrl).concat(_search ? "?".concat(_search) : '');
  }
  var baseUrl = url.slice(0, hashIndex);
  var hash = url.slice(hashIndex + 1);
  var queryIndex = hash.indexOf('?');
  var hashPath = queryIndex === -1 ? hash : hash.slice(0, queryIndex);
  var query = qs.parse(queryIndex === -1 ? '' : hash.slice(queryIndex + 1));
  Object.keys(params).forEach(function (key) {
    return setQueryParam(query, key, params[key]);
  });
  var search = qs.stringify(query);
  return "".concat(baseUrl, "#").concat(hashPath).concat(search ? "?".concat(search) : '');
}
function removeQueryFromHashUrl(url, keys) {
  var hashIndex = url.indexOf('#');
  if (hashIndex === -1) {
    return removeQueryFromUrl(url, keys);
  }
  var baseUrl = removeQueryFromUrl(url.slice(0, hashIndex), keys);
  var hash = removeQueryFromUrl(url.slice(hashIndex + 1), keys);
  return "".concat(baseUrl, "#").concat(hash);
}
function getCurrentSsoTransferCode() {
  var hashQueryCode = getQueryValue(getUrlQuery()[SSO_TRANSFER_CODE_QUERY_KEY]);
  if (hashQueryCode) {
    return hashQueryCode;
  }
  var searchQuery = qs.parse(window.location.search.slice(1));
  return getQueryValue(searchQuery[SSO_TRANSFER_CODE_QUERY_KEY]);
}
export function getAccessTokenLegacyData() {
  try {
    var token = getDecodedToken();
    if (token) {
      if (token.biz) {
        return JSON.parse(JSON.parse(token.biz.legacy).data);
      }
    }
    return null;
  } catch (e) {
    console.warn(e);
    return null;
  }
}
export function isInternalUser() {
  try {
    var token = getDecodedToken();
    if (token && token.biz && token.biz.mt) {
      return JSON.parse(JSON.parse(token.biz.mt).data); // mt.data是'false'字符串，需要再parse一下
    }

    return false;
  } catch (err) {
    console.warn(err);
    return false;
  }
}
/**
 * 获取用户登录的类型，如果无法获取 token，则返回 null
 * @returns USER_LOGIN_TYPE | null
 */
export function getUserLoginType() {
  try {
    var token = getDecodedToken();
    if (token) {
      var _token$biz;
      if (token.sLdap) {
        return USER_LOGIN_TYPE.DESIGNATION;
      }
      if ((_token$biz = token.biz) === null || _token$biz === void 0 ? void 0 : _token$biz.templ) {
        return USER_LOGIN_TYPE.TEMP_LINK;
      }
      return USER_LOGIN_TYPE.NORMAL;
    }
    return null;
  } catch (e) {
    console.warn(e);
    return null;
  }
}
// 本地时间 - 服务器时间的差值
export function getAtDiffTime() {
  return Number(getStorage(CODE_LOGIN.AT_DIFF_TIME) || 0);
}
export function saveTokenToStorage(accessToken, refreshToken, cookieOptions) {
  var op = cookieOptions || {};
  var domain = getCookieDomain();
  if (accessToken) {
    var _decode = decode(accessToken),
      exp = _decode.exp;
    setStorage(CODE_LOGIN.ACCESS_TOKEN_TIMEOUT, String(new Date(exp * 1000).getTime()), _objectSpread({
      domain: domain,
      path: '/',
      expires: 365
    }, op));
    setStorage(CODE_LOGIN.ACCESS_TOKEN, accessToken, _objectSpread({
      domain: domain,
      path: '/',
      expires: 365
    }, op));
  }
  if (refreshToken) {
    var _decode2 = decode(refreshToken),
      exp2 = _decode2.exp;
    setStorage(CODE_LOGIN.REFRESH_TOKEN_TIMEOUT, String(new Date(exp2 * 1000).getTime()), _objectSpread({
      domain: domain,
      path: '/',
      expires: 365
    }, op));
    setStorage(CODE_LOGIN.REFRESH_TOKEN, refreshToken, _objectSpread({
      domain: domain,
      path: '/',
      expires: 365
    }, op));
  }
  emitter.emit('saveTokenToStorage', {
    at: accessToken,
    rt: refreshToken
  });
}
export function cleanLoginStorage() {
  var domain = getCookieDomain();
  removeStorage(CODE_LOGIN.ACCESS_TOKEN, {
    path: '/',
    domain: domain
  });
  removeStorage(CODE_LOGIN.REFRESH_TOKEN, {
    path: '/',
    domain: domain
  });
  removeStorage(CODE_LOGIN.ACCESS_TOKEN_TIMEOUT, {
    path: '/',
    domain: domain
  });
  removeStorage(CODE_LOGIN.REFRESH_TOKEN_TIMEOUT, {
    path: '/',
    domain: domain
  });
  removeStorage(CODE_LOGIN.AT_DIFF_TIME, {
    path: '/',
    domain: domain
  });
  localStorage.removeItem(storageTidKey);
  Cookie.remove('metis_wx');
  emitter.emit('cleanLoginStorage');
}
export function loginByCode(_x) {
  return _loginByCode.apply(this, arguments);
}
function _loginByCode() {
  _loginByCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(params) {
    var _res$data2;
    var res, _res$data$result, accessToken, refreshToken;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return verifyCodeLogin(params);
        case 2:
          res = _context2.sent;
          if ((res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.code) === '0') {
            _res$data$result = res.data.result, accessToken = _res$data$result.accessToken, refreshToken = _res$data$result.refreshToken;
            saveTokenToStorage(accessToken, refreshToken);
          }
          return _context2.abrupt("return", res);
        case 5:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _loginByCode.apply(this, arguments);
}
export function loginByPsw(_x2) {
  return _loginByPsw.apply(this, arguments);
}
function _loginByPsw() {
  _loginByPsw = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(params) {
    var _res$data3;
    var res, _res$data$result2, accessToken, refreshToken;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return phonePasswordLogin(params);
        case 2:
          res = _context3.sent;
          if ((res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.code) === '0') {
            _res$data$result2 = res.data.result, accessToken = _res$data$result2.accessToken, refreshToken = _res$data$result2.refreshToken;
            saveTokenToStorage(accessToken, refreshToken);
          }
          return _context3.abrupt("return", res);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _loginByPsw.apply(this, arguments);
}
export function loginByDesignation(_x3) {
  return _loginByDesignation.apply(this, arguments);
}
function _loginByDesignation() {
  _loginByDesignation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(designation) {
    var _res$data4, res, _res$data$result3, accessToken, refreshToken;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.prev = 0;
          _context4.next = 3;
          return designationLogin(designation);
        case 3:
          res = _context4.sent;
          if ((res === null || res === void 0 ? void 0 : (_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : _res$data4.code) === '0') {
            _res$data$result3 = res.data.result, accessToken = _res$data$result3.accessToken, refreshToken = _res$data$result3.refreshToken;
            saveTokenToStorage(accessToken, refreshToken);
          }
          return _context4.abrupt("return", res);
        case 8:
          _context4.prev = 8;
          _context4.t0 = _context4["catch"](0);
          console.warn(_context4.t0);
          return _context4.abrupt("return", _context4.t0 === null || _context4.t0 === void 0 ? void 0 : _context4.t0.response);
        case 12:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[0, 8]]);
  }));
  return _loginByDesignation.apply(this, arguments);
}
export function loginByStudentDesignation(_x4) {
  return _loginByStudentDesignation.apply(this, arguments);
}
function _loginByStudentDesignation() {
  _loginByStudentDesignation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(designation) {
    var _res$data5, res, _res$data$result4, accessToken, refreshToken;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.prev = 0;
          _context5.next = 3;
          return designationStudentLogin(designation);
        case 3:
          res = _context5.sent;
          if ((res === null || res === void 0 ? void 0 : (_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : _res$data5.code) === '0') {
            _res$data$result4 = res.data.result, accessToken = _res$data$result4.accessToken, refreshToken = _res$data$result4.refreshToken;
            saveTokenToStorage(accessToken, refreshToken);
          }
          return _context5.abrupt("return", res);
        case 8:
          _context5.prev = 8;
          _context5.t0 = _context5["catch"](0);
          console.warn(_context5.t0);
          return _context5.abrupt("return", _context5.t0 === null || _context5.t0 === void 0 ? void 0 : _context5.t0.response);
        case 12:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[0, 8]]);
  }));
  return _loginByStudentDesignation.apply(this, arguments);
}
export function loginByOpenLogin(_x5) {
  return _loginByOpenLogin.apply(this, arguments);
}
function _loginByOpenLogin() {
  _loginByOpenLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(openCode) {
    var _res$data6, res, _res$data$result5, accessToken, refreshToken;
    return _regeneratorRuntime().wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          _context6.prev = 0;
          _context6.next = 3;
          return openLogin(openCode);
        case 3:
          res = _context6.sent;
          if ((res === null || res === void 0 ? void 0 : (_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : _res$data6.code) === '0') {
            _res$data$result5 = res.data.result, accessToken = _res$data$result5.accessToken, refreshToken = _res$data$result5.refreshToken;
            saveTokenToStorage(accessToken, refreshToken, {
              secure: true,
              sameSite: 'none'
            });
          }
          return _context6.abrupt("return", res);
        case 8:
          _context6.prev = 8;
          _context6.t0 = _context6["catch"](0);
          console.warn(_context6.t0);
          return _context6.abrupt("return", _context6.t0 === null || _context6.t0 === void 0 ? void 0 : _context6.t0.response);
        case 12:
        case "end":
          return _context6.stop();
      }
    }, _callee6, null, [[0, 8]]);
  }));
  return _loginByOpenLogin.apply(this, arguments);
}
export function loginByOpenLoginV2(_x6) {
  return _loginByOpenLoginV.apply(this, arguments);
}
function _loginByOpenLoginV() {
  _loginByOpenLoginV = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(openCode) {
    var _res$data7, res, _res$data$result6, accessToken, refreshToken;
    return _regeneratorRuntime().wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.prev = 0;
          _context7.next = 3;
          return openLoginV2(openCode);
        case 3:
          res = _context7.sent;
          if ((res === null || res === void 0 ? void 0 : (_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : _res$data7.code) === '0') {
            _res$data$result6 = res.data.result, accessToken = _res$data$result6.accessToken, refreshToken = _res$data$result6.refreshToken;
            console.log('v2 new at:', accessToken);
            console.log('v2 new rt:', refreshToken);
            saveTokenToStorage(accessToken, refreshToken);
          }
          return _context7.abrupt("return", res);
        case 8:
          _context7.prev = 8;
          _context7.t0 = _context7["catch"](0);
          console.warn(_context7.t0);
          return _context7.abrupt("return", _context7.t0 === null || _context7.t0 === void 0 ? void 0 : _context7.t0.response);
        case 12:
        case "end":
          return _context7.stop();
      }
    }, _callee7, null, [[0, 8]]);
  }));
  return _loginByOpenLoginV.apply(this, arguments);
}
export function ssoRedirect(_x7) {
  return _ssoRedirect.apply(this, arguments);
}
function _ssoRedirect() {
  _ssoRedirect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(redirectUrl) {
    var _res$data8;
    var openInNewPage,
      res,
      code,
      targetUrl,
      _args8 = arguments;
    return _regeneratorRuntime().wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          openInNewPage = _args8.length > 1 && _args8[1] !== undefined ? _args8[1] : false;
          _context8.next = 3;
          return createSsoTransferCode({
            redirectUri: redirectUrl
          });
        case 3:
          res = _context8.sent;
          if ((res === null || res === void 0 ? void 0 : (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.code) === '0') {
            code = res.data.result.code;
            targetUrl = appendQueryToHashUrl(redirectUrl, _defineProperty({}, SSO_TRANSFER_CODE_QUERY_KEY, code));
            if (openInNewPage) {
              window.open(targetUrl, '_blank');
            } else {
              window.location.replace(targetUrl);
            }
          }
          return _context8.abrupt("return", res);
        case 6:
        case "end":
          return _context8.stop();
      }
    }, _callee8);
  }));
  return _ssoRedirect.apply(this, arguments);
}
export function loginBySsoCode(_x8) {
  return _loginBySsoCode.apply(this, arguments);
}
function _loginBySsoCode() {
  _loginBySsoCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(loginConfig) {
    var _res$data9;
    var _ref8, _ref8$ssoTransferCode, ssoTransferCode, _ref8$redirectUri, redirectUri, userAgent, _ref8$cleanUrl, cleanUrl, res, _window$history, _res$data$result7, accessToken, refreshToken;
    return _regeneratorRuntime().wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          _ref8 = loginConfig || {}, _ref8$ssoTransferCode = _ref8.ssoTransferCode, ssoTransferCode = _ref8$ssoTransferCode === void 0 ? getCurrentSsoTransferCode() : _ref8$ssoTransferCode, _ref8$redirectUri = _ref8.redirectUri, redirectUri = _ref8$redirectUri === void 0 ? removeQueryFromHashUrl(window.location.href, SSO_QUERY_KEYS) : _ref8$redirectUri, userAgent = _ref8.userAgent, _ref8$cleanUrl = _ref8.cleanUrl, cleanUrl = _ref8$cleanUrl === void 0 ? true : _ref8$cleanUrl;
          if (ssoTransferCode) {
            _context9.next = 3;
            break;
          }
          return _context9.abrupt("return", null);
        case 3:
          _context9.next = 5;
          return exchangeSsoCodeForToken({
            code: ssoTransferCode,
            redirectUri: redirectUri,
            userAgent: userAgent
          });
        case 5:
          res = _context9.sent;
          if ((res === null || res === void 0 ? void 0 : (_res$data9 = res.data) === null || _res$data9 === void 0 ? void 0 : _res$data9.code) === '0') {
            _res$data$result7 = res.data.result, accessToken = _res$data$result7.accessToken, refreshToken = _res$data$result7.refreshToken;
            saveTokenToStorage(accessToken, refreshToken);
            if (cleanUrl && ((_window$history = window.history) === null || _window$history === void 0 ? void 0 : _window$history.replaceState)) {
              window.history.replaceState({}, '', removeQueryFromHashUrl(window.location.href, SSO_QUERY_KEYS));
            }
          }
          return _context9.abrupt("return", res);
        case 8:
        case "end":
          return _context9.stop();
      }
    }, _callee9);
  }));
  return _loginBySsoCode.apply(this, arguments);
}
var ssoCodeLoginPromise = null;
function tryLoginBySsoCode(_x9) {
  return _tryLoginBySsoCode.apply(this, arguments);
}
function _tryLoginBySsoCode() {
  _tryLoginBySsoCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(loginConfig) {
    return _regeneratorRuntime().wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          if (!(!getCurrentSsoTransferCode() && !(loginConfig === null || loginConfig === void 0 ? void 0 : loginConfig.ssoTransferCode))) {
            _context10.next = 2;
            break;
          }
          return _context10.abrupt("return", true);
        case 2:
          if (!ssoCodeLoginPromise) {
            ssoCodeLoginPromise = loginBySsoCode(loginConfig).then(function (res) {
              var _res$data10;
              return !res || (res === null || res === void 0 ? void 0 : (_res$data10 = res.data) === null || _res$data10 === void 0 ? void 0 : _res$data10.code) === '0';
            }).catch(function (e) {
              console.warn(e);
              return false;
            }).finally(function () {
              ssoCodeLoginPromise = null;
            });
          }
          return _context10.abrupt("return", ssoCodeLoginPromise);
        case 4:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  return _tryLoginBySsoCode.apply(this, arguments);
}
export function loginByFlying(_x10) {
  return _loginByFlying.apply(this, arguments);
}
function _loginByFlying() {
  _loginByFlying = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(params) {
    var _res$data11;
    var res, _res$data$result8, accessToken, refreshToken;
    return _regeneratorRuntime().wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return flyingLogin(params);
        case 2:
          res = _context11.sent;
          if ((res === null || res === void 0 ? void 0 : (_res$data11 = res.data) === null || _res$data11 === void 0 ? void 0 : _res$data11.code) === '0') {
            _res$data$result8 = res.data.result, accessToken = _res$data$result8.accessToken, refreshToken = _res$data$result8.refreshToken;
            saveTokenToStorage(accessToken, refreshToken);
          }
          return _context11.abrupt("return", res);
        case 5:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  return _loginByFlying.apply(this, arguments);
}
export function isDesignationLogin() {
  var at = getAccessToken();
  var rt = getRefreshToken();
  return at && !rt;
}
export function goDesignationLogin(designationCode, redirectUrl) {
  if (typeof designationCode !== 'string') {
    var code = designationCode.designationCode,
      url = designationCode.redirectUrl,
      inNew = designationCode.openInNewPage;
    var targetUrl = "".concat(config.designationLoginURL, "?designationCode=").concat(code, "&redirectUrl=").concat(encodeURIComponent(url || ''));
    if (inNew) {
      window.open(targetUrl, '_blank');
    } else {
      // window.location.replace(targetUrl)
      window.location.href = targetUrl;
    }
  } else {
    // window.location.replace(`${config.designationLoginURL}?designationCode=${designationCode}&redirectUrl=${encodeURIComponent(redirectUrl || '')}`)
    window.location.href = "".concat(config.designationLoginURL, "?designationCode=").concat(designationCode, "&redirectUrl=").concat(encodeURIComponent(redirectUrl || ''));
  }
}
export function goDesignationStudentLogin(designationCode, redirectUrl) {
  if (typeof designationCode !== 'string') {
    var code = designationCode.designationCode,
      url = designationCode.redirectUrl,
      inNew = designationCode.openInNewPage;
    var targetUrl = "".concat(config.designationStudentLoginURL, "?designationCode=").concat(code, "&redirectUrl=").concat(encodeURIComponent(url || ''));
    if (inNew) {
      window.open(targetUrl, '_blank');
    } else {
      // window.location.replace(targetUrl)
      window.location.href = targetUrl;
    }
  } else {
    // window.location.replace(`${config.designationStudentLoginURL}?designationCode=${designationCode}&redirectUrl=${encodeURIComponent(redirectUrl || '')}`)
    window.location.href = "".concat(config.designationStudentLoginURL, "?designationCode=").concat(designationCode, "&redirectUrl=").concat(encodeURIComponent(redirectUrl || ''));
  }
}
export function goOpenLogin(openCode, redirectUrl) {
  if (typeof openCode !== 'string') {
    var code = openCode.openCode,
      url = openCode.redirectUrl,
      inNew = openCode.openInNewPage;
    var targetUrl = "".concat(config.openLoginURL, "?code=").concat(code, "&redirectUrl=").concat(encodeURIComponent(url || ''));
    if (inNew) {
      window.open(targetUrl, '_blank');
    } else {
      window.location.href = targetUrl;
    }
  } else {
    window.location.href = "".concat(config.openLoginURL, "?code=").concat(openCode, "&redirectUrl=").concat(encodeURIComponent(redirectUrl || ''));
  }
}
var defaultRefreshUrl = REFRESH_URL.AUTH;
export function setDefaultRefreshUrl(url) {
  defaultRefreshUrl = url;
}
var refreshSuccessCallback = function refreshSuccessCallback(at, rt) {};
export function setRefreshSuccessCallback(cb) {
  refreshSuccessCallback = cb;
}
export function refreshLoginByCode(_x11) {
  return _refreshLoginByCode.apply(this, arguments);
}
function _refreshLoginByCode() {
  _refreshLoginByCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(params) {
    var resolve, url, p, oldTid, res, code, _res$data$result9, accessToken, refreshToken, curTid, _p, _e$response, _e$response$data, _e$response2, _e$response2$data, _e$response3, _e$response3$data;
    return _regeneratorRuntime().wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          resolve = function resolve(res) {};
          _context12.prev = 1;
          if (refreshing) {
            _context12.next = 31;
            break;
          }
          refreshing = true;
          refreshingPromise = new Promise(function (r) {
            resolve = r;
          });
          url = (params === null || params === void 0 ? void 0 : params.url) || defaultRefreshUrl;
          p = _objectSpread(_objectSpread({
            refreshToken: getRefreshToken()
          }, params || {}), {}, {
            url: url,
            tenantId: (params === null || params === void 0 ? void 0 : params.tenantId) || getTokenTenantId()
          });
          oldTid = getTokenTenantId();
          _context12.next = 10;
          return refreshCodeToken(p);
        case 10:
          res = _context12.sent;
          code = res.data.code;
          refreshing = false;
          if (!(code === '0')) {
            _context12.next = 24;
            break;
          }
          _res$data$result9 = res.data.result, accessToken = _res$data$result9.accessToken, refreshToken = _res$data$result9.refreshToken;
          saveTokenToStorage(accessToken, refreshToken);
          refreshSuccessCallback(accessToken, refreshToken);
          emitter.emit('refreshSuccess', {
            at: accessToken,
            rt: refreshToken
          });
          resolve(true);
          curTid = getTokenTenantId();
          delaySetLocalStorage(function () {
            localStorage.setItem(storageTidKeyOld, oldTid ? String(oldTid) : '');
            localStorage.setItem(storageTidKeyNew, curTid ? String(curTid) : '');
          });
          localStorage.setItem(storageTidKey, curTid ? String(curTid) : '');
          _context12.next = 29;
          break;
        case 24:
          if (![ERROR_CODE.REFRESH_FAIL, ERROR_CODE.REFRESH_OVER_FREQ, ERROR_CODE.REVOKED_TOKEN].includes(code)) {
            _context12.next = 27;
            break;
          }
          resolve(code);
          return _context12.abrupt("return", code);
        case 27:
          resolve(false);
          return _context12.abrupt("return", false);
        case 29:
          _context12.next = 35;
          break;
        case 31:
          _context12.next = 33;
          return refreshingPromise;
        case 33:
          _p = _context12.sent;
          return _context12.abrupt("return", _p);
        case 35:
          return _context12.abrupt("return", true);
        case 38:
          _context12.prev = 38;
          _context12.t0 = _context12["catch"](1);
          console.warn(_context12.t0);
          console.warn(_context12.t0 === null || _context12.t0 === void 0 ? void 0 : _context12.t0.response);
          refreshing = false;
          if (![ERROR_CODE.REVOKED_TOKEN, ERROR_CODE.REFRESH_FAIL, ERROR_CODE.REFRESH_OVER_FREQ].includes(_context12.t0 === null || _context12.t0 === void 0 ? void 0 : (_e$response = _context12.t0.response) === null || _e$response === void 0 ? void 0 : (_e$response$data = _e$response.data) === null || _e$response$data === void 0 ? void 0 : _e$response$data.code)) {
            _context12.next = 46;
            break;
          }
          resolve(_context12.t0 === null || _context12.t0 === void 0 ? void 0 : (_e$response2 = _context12.t0.response) === null || _e$response2 === void 0 ? void 0 : (_e$response2$data = _e$response2.data) === null || _e$response2$data === void 0 ? void 0 : _e$response2$data.code);
          return _context12.abrupt("return", _context12.t0 === null || _context12.t0 === void 0 ? void 0 : (_e$response3 = _context12.t0.response) === null || _e$response3 === void 0 ? void 0 : (_e$response3$data = _e$response3.data) === null || _e$response3$data === void 0 ? void 0 : _e$response3$data.code);
        case 46:
          resolve(false);
          return _context12.abrupt("return", false);
        case 48:
        case "end":
          return _context12.stop();
      }
    }, _callee12, null, [[1, 38]]);
  }));
  return _refreshLoginByCode.apply(this, arguments);
}
export function judgeExpired(key, offset) {
  try {
    var timeout = getStorage(key);
    if (timeout) {
      var exp = +timeout - offset + getAtDiffTime();
      // console.log('exp', exp, new Date(exp).toLocaleString())
      // console.log('Date.now()', Date.now(), new Date().toLocaleString())
      // console.log(exp > Date.now())
      // console.log('-------')
      if (exp > Date.now()) {
        return false;
      }
    }
  } catch (e) {
    console.warn(e);
    return true;
  }
  return true;
}
export function codeAccessTokenExpired(offset) {
  return judgeExpired(CODE_LOGIN.ACCESS_TOKEN_TIMEOUT, offset || atExpiredOffset);
}
export function codeRefreshTokenExpired(offset) {
  return judgeExpired(CODE_LOGIN.REFRESH_TOKEN_TIMEOUT, offset || rtExpiredOffset);
}
// 当前已经登录了，并且不是代客登录的情况下，判断refreshtoken是否在ms毫秒内过期
export function willExpiredInMs(ms) {
  // at没过期，说明已经登录了
  if (!codeAccessTokenExpired()) {
    return codeRefreshTokenExpired(ms) && !isDesignationLogin();
  }
  // at过期，rt没过期，也可以认为已经登录了，因为此时可以用rt刷新at
  if (!codeRefreshTokenExpired()) {
    return codeRefreshTokenExpired(ms) && !isDesignationLogin();
  }
  // 没有登录，不符合前置条件，直接返回false
  return false;
}
export function userLoginButNotChooseRole(_x12) {
  return _userLoginButNotChooseRole.apply(this, arguments);
}
function _userLoginButNotChooseRole() {
  _userLoginButNotChooseRole = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(params) {
    var _ref9, tenants, _ref10, refreshUrl, _ref10$includesPerson, includesPersonal, atTimeoutOffset, accessToken, res, tenantId;
    return _regeneratorRuntime().wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          _context13.prev = 0;
          _ref9 = params || {}, tenants = _ref9.tenants;
          _ref10 = params || {}, refreshUrl = _ref10.refreshUrl, _ref10$includesPerson = _ref10.includesPersonal, includesPersonal = _ref10$includesPerson === void 0 ? false : _ref10$includesPerson, atTimeoutOffset = _ref10.atTimeoutOffset;
          accessToken = getAccessToken();
          if (!accessToken) {
            _context13.next = 26;
            break;
          }
          if (!codeAccessTokenExpired(atTimeoutOffset)) {
            _context13.next = 12;
            break;
          }
          _context13.next = 8;
          return refreshLoginByCode({
            url: refreshUrl
          });
        case 8:
          res = _context13.sent;
          if (!(res !== true)) {
            _context13.next = 11;
            break;
          }
          return _context13.abrupt("return", false);
        case 11:
          accessToken = getAccessToken();
        case 12:
          if (tenants) {
            _context13.next = 16;
            break;
          }
          _context13.next = 15;
          return getUserTenants();
        case 15:
          tenants = _context13.sent.data.result;
        case 16:
          if (!(tenants.length === 0)) {
            _context13.next = 18;
            break;
          }
          return _context13.abrupt("return", true);
        case 18:
          tenantId = getTokenTenantId(); // 个人版的 ID 是 -1，所以只有当ID是空的时候才属于没选学校的情况
          if (!includesPersonal) {
            _context13.next = 24;
            break;
          }
          if (tenantId) {
            _context13.next = 22;
            break;
          }
          return _context13.abrupt("return", true);
        case 22:
          _context13.next = 26;
          break;
        case 24:
          if (!(!tenantId || String(tenantId) === '-1')) {
            _context13.next = 26;
            break;
          }
          return _context13.abrupt("return", true);
        case 26:
          return _context13.abrupt("return", false);
        case 29:
          _context13.prev = 29;
          _context13.t0 = _context13["catch"](0);
          console.warn(_context13.t0);
          return _context13.abrupt("return", false);
        case 33:
        case "end":
          return _context13.stop();
      }
    }, _callee13, null, [[0, 29]]);
  }));
  return _userLoginButNotChooseRole.apply(this, arguments);
}
export function getTokenTenantId() {
  var _getAccessTokenLegacy, _getDecodedToken;
  // @ts-ignore
  var tenantId = ((_getAccessTokenLegacy = getAccessTokenLegacyData()) === null || _getAccessTokenLegacy === void 0 ? void 0 : _getAccessTokenLegacy.tenantId) || ((_getDecodedToken = getDecodedToken()) === null || _getDecodedToken === void 0 ? void 0 : _getDecodedToken.tid);
  return tenantId ? Number(tenantId) : undefined;
}
export function filterRoles(r) {
  var teacher = [];
  var student = [];
  r.forEach(function (item) {
    if (item.identityTypes.includes(IDENTITY_TYPES.TEACHER)) {
      teacher.push(item);
    }
    if (item.identityTypes.includes(IDENTITY_TYPES.STUDENT)) {
      student.push(item);
    }
  });
  return {
    teacher: teacher,
    student: student
  };
}
var pdf;
export function isPdf() {
  if (pdf !== undefined) {
    return pdf;
  }
  pdf = !!getUrlQuery().accessToken;
  return pdf;
}
export function getSearch() {
  var search = "?redirectUrl=".concat(encodeURIComponent(window.location.href));
  // let search = `?redirectUrl=${encodeURIComponent(window.location.href)}&ca=${CAConfig.ca}`
  if (notGetSearchPath.some(function (path) {
    return getUrlPath() === path;
  })) {
    search = "?redirectUrl=".concat(encodeURIComponent("".concat(window.location.origin).concat(window.location.pathname).concat(window.location.search)));
    // search = `?redirectUrl=${encodeURIComponent(`${window.location.origin}${window.location.pathname}${window.location.search}`)}&ca=${CAConfig.ca}`
  }

  var s = window.location.hash.split('?')[1];
  if (s) {
    var parseSearch = qs.parse(s);
    if (parseSearch.redirectUrl) {
      if (parseSearch.ca) {
        return "?".concat(s);
      }
      // return `?${s}&ca=${CAConfig.ca}`
      // 暂时不把 ca 放URL上
      return "?".concat(s);
    }
  }
  return search;
}
export function closeIfHasOpener() {
  if (window.opener) {
    var origin = '*';
    var redirect = getUrlQuery().redirectUrl;
    if (redirect) {
      origin = decodeURIComponent(redirect).split('#')[0].slice(0, -1);
    }
    window.opener.postMessage({
      loginSuccess: true
    }, origin);
  }
}
export function loginInNewPage() {
  var search = getSearch();
  window.open(config.loginURL + search, '_blank');
  var onReceiveMessage = function onReceiveMessage(e) {
    if (e.origin === config.loginURL.split('#')[0].slice(0, -1)) {
      if (e.data.loginSuccess) {
        var _e$source;
        // @ts-ignore
        e === null || e === void 0 ? void 0 : (_e$source = e.source) === null || _e$source === void 0 ? void 0 : _e$source.close();
        window.removeEventListener('message', onReceiveMessage);
      }
    }
  };
  window.removeEventListener('message', onReceiveMessage);
  window.addEventListener('message', onReceiveMessage);
}
var customGoToLogin;
export function goToLogin(loginConfig) {
  if (customGoToLogin && customGoToLogin instanceof Function) {
    customGoToLogin(loginConfig);
    return;
  }
  cleanLoginStorage();
  if (loginConfig === null || loginConfig === void 0 ? void 0 : loginConfig.openInNewPage) {
    loginInNewPage();
    return;
  }
  // 重置密码页面或者当前已经在登录页了，不需要去登录
  if ((loginConfig === null || loginConfig === void 0 ? void 0 : loginConfig.force) || notGoToLoginPath.every(function (path) {
    return getUrlPath() !== path;
  })) {
    var search = getSearch();
    // window.location.replace(config.loginURL + search)
    window.location.href = config.loginURL + search;
  }
}
export function replaceGoToLogin(fn) {
  customGoToLogin = fn;
}
// --- ResponseFulfilledInterceptor start
var defaultWhenResponseFulfilledInterceptorRefreshFailFn = function defaultWhenResponseFulfilledInterceptorRefreshFailFn() {
  return goToLogin();
};
export function replaceWhenResponseFulfilledInterceptorRefreshFailFn(fn) {
  defaultWhenResponseFulfilledInterceptorRefreshFailFn = fn;
}
export function whenResponseFulfilledInterceptorRefreshFail(res) {
  if (typeof defaultWhenResponseFulfilledInterceptorRefreshFailFn === 'function') {
    defaultWhenResponseFulfilledInterceptorRefreshFailFn(res);
  }
}
// --- ResponseFulfilledInterceptor end
export function goToSetOrChoose() {
  var search = getSearch();
  // window.location.replace(config.chooseURL + search)
  window.location.href = config.chooseURL + search;
}
var customGoToChooseSchool;
export function goToChooseSchool() {
  if (customGoToChooseSchool && customGoToChooseSchool instanceof Function) {
    customGoToChooseSchool();
    return;
  }
  var search = getSearch();
  // window.location.replace(config.chooseURL + search)
  window.location.href = config.chooseURL + search;
}
export function replaceGoToChooseSchool(fn) {
  customGoToChooseSchool = fn;
}
var customGoToPerfectData;
export function goToPerfectData() {
  if (customGoToPerfectData && customGoToPerfectData instanceof Function) {
    customGoToPerfectData();
    return;
  }
  var search = getSearch();
  // window.location.replace(config.perfectURL + search)
  window.location.href = config.perfectURL + search;
}
export function replaceGoToPerfectData(fn) {
  customGoToPerfectData = fn;
}
export function switchSchool() {
  var search = getSearch();
  if (search.startsWith('?')) {
    search = "".concat(search, "&switchSchool=1");
  } else {
    search = '?switchSchool=1';
  }
  // window.location.replace(config.chooseURL + search)
  window.location.href = config.chooseURL + search;
}
var checkoutLoginPromise = Promise.resolve(true);
var checkouting = false;
var customCheckoutLogin;
export function replaceCheckoutLogin(fn) {
  customCheckoutLogin = fn;
}
export function checkoutLogin(_x13) {
  return _checkoutLogin.apply(this, arguments);
}
function _checkoutLogin() {
  _checkoutLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(loginConfig) {
    var resolve, _ref11, _ref11$jumpLogin, jumpLogin, refreshUrl, atTimeoutOffset, rtTimeoutOffset, res, p;
    return _regeneratorRuntime().wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return tryLoginBySsoCode();
        case 2:
          if (!(customCheckoutLogin && customCheckoutLogin instanceof Function)) {
            _context14.next = 4;
            break;
          }
          return _context14.abrupt("return", customCheckoutLogin(loginConfig));
        case 4:
          resolve = function resolve(res) {};
          _ref11 = loginConfig || {}, _ref11$jumpLogin = _ref11.jumpLogin, jumpLogin = _ref11$jumpLogin === void 0 ? true : _ref11$jumpLogin, refreshUrl = _ref11.refreshUrl, atTimeoutOffset = _ref11.atTimeoutOffset, rtTimeoutOffset = _ref11.rtTimeoutOffset;
          _context14.prev = 6;
          if (checkouting) {
            _context14.next = 34;
            break;
          }
          checkouting = true;
          checkoutLoginPromise = new Promise(function (r, re) {
            resolve = r;
          });
          if (!isPdf()) {
            _context14.next = 14;
            break;
          }
          checkouting = false;
          resolve(true);
          return _context14.abrupt("return", true);
        case 14:
          if (!codeAccessTokenExpired(atTimeoutOffset)) {
            _context14.next = 30;
            break;
          }
          if (!codeRefreshTokenExpired(rtTimeoutOffset)) {
            _context14.next = 20;
            break;
          }
          // accessToken 过期并且 refreshToken也过期，需要登录
          checkouting = false;
          resolve(false);
          if (jumpLogin) {
            goToLogin();
          }
          return _context14.abrupt("return", false);
        case 20:
          _context14.next = 22;
          return refreshLoginByCode({
            url: refreshUrl
          });
        case 22:
          res = _context14.sent;
          if (!([ERROR_CODE.REFRESH_FAIL, ERROR_CODE.REFRESH_OVER_FREQ, ERROR_CODE.REVOKED_TOKEN].includes(res) || res === false)) {
            _context14.next = 30;
            break;
          }
          logOutService();
          checkouting = false;
          resolve(false);
          cleanLoginStorage();
          if (jumpLogin) {
            goToLogin();
          }
          return _context14.abrupt("return", false);
        case 30:
          checkouting = false;
          resolve(true);
          _context14.next = 38;
          break;
        case 34:
          _context14.next = 36;
          return checkoutLoginPromise;
        case 36:
          p = _context14.sent;
          return _context14.abrupt("return", p);
        case 38:
          _context14.next = 46;
          break;
        case 40:
          _context14.prev = 40;
          _context14.t0 = _context14["catch"](6);
          console.warn(_context14.t0);
          checkouting = false;
          resolve(false);
          return _context14.abrupt("return", false);
        case 46:
          return _context14.abrupt("return", true);
        case 47:
        case "end":
          return _context14.stop();
      }
    }, _callee14, null, [[6, 40]]);
  }));
  return _checkoutLogin.apply(this, arguments);
}
export function initLogin(_x14) {
  return _initLogin.apply(this, arguments);
}
function _initLogin() {
  _initLogin = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(props) {
    var _ref12, _ref12$jumpLogin, jumpLogin, refreshUrl, whenNoPermission, whenNotChooseRole, whenNotLogin, whenSuccess, whenError, _ref13, tenants, login, _yield$Promise$all, _yield$Promise$all2, t, res;
    return _regeneratorRuntime().wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          _ref12 = props || {}, _ref12$jumpLogin = _ref12.jumpLogin, jumpLogin = _ref12$jumpLogin === void 0 ? true : _ref12$jumpLogin, refreshUrl = _ref12.refreshUrl, whenNoPermission = _ref12.whenNoPermission, whenNotChooseRole = _ref12.whenNotChooseRole, whenNotLogin = _ref12.whenNotLogin, whenSuccess = _ref12.whenSuccess, whenError = _ref12.whenError;
          _ref13 = props || {}, tenants = _ref13.tenants;
          _context15.prev = 2;
          if (refreshUrl) {
            setDefaultRefreshUrl(refreshUrl);
          }
          _context15.next = 6;
          return checkoutLogin({
            jumpLogin: jumpLogin,
            refreshUrl: refreshUrl
          });
        case 6:
          login = _context15.sent;
          if (!login) {
            _context15.next = 26;
            break;
          }
          if (tenants) {
            _context15.next = 15;
            break;
          }
          _context15.next = 11;
          return Promise.all([getUserTenants()]);
        case 11:
          _yield$Promise$all = _context15.sent;
          _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 1);
          t = _yield$Promise$all2[0].data.result;
          tenants = t;
        case 15:
          if (!(tenants.length === 0)) {
            _context15.next = 18;
            break;
          }
          if (whenNoPermission) {
            whenNoPermission(tenants);
          } else {
            goNoPermission();
          }
          return _context15.abrupt("return", {
            code: '403',
            message: 'no permission',
            data: tenants
          });
        case 18:
          _context15.next = 20;
          return userLoginButNotChooseRole({
            tenants: tenants,
            refreshUrl: refreshUrl
          });
        case 20:
          res = _context15.sent;
          if (!res) {
            _context15.next = 24;
            break;
          }
          if (whenNotChooseRole) {
            whenNotChooseRole(tenants);
          } else {
            goToChooseSchool();
          }
          return _context15.abrupt("return", {
            code: '1',
            message: 'not choose role',
            data: tenants
          });
        case 24:
          if (whenSuccess) {
            whenSuccess();
          }
          return _context15.abrupt("return", {
            code: '0',
            message: 'success',
            data: null
          });
        case 26:
          if (whenNotLogin) {
            whenNotLogin();
          }
          return _context15.abrupt("return", {
            code: '401',
            message: 'not login',
            data: null
          });
        case 30:
          _context15.prev = 30;
          _context15.t0 = _context15["catch"](2);
          console.warn(_context15.t0);
          if (whenError) {
            whenError(_context15.t0);
          }
          return _context15.abrupt("return", {
            code: '-1',
            message: 'error',
            data: _context15.t0
          });
        case 35:
        case "end":
          return _context15.stop();
      }
    }, _callee15, null, [[2, 30]]);
  }));
  return _initLogin.apply(this, arguments);
}
export function logOut(_x15, _x16) {
  return _logOut.apply(this, arguments);
}
function _logOut() {
  _logOut = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(redirectUrl, timeout) {
    return _regeneratorRuntime().wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          _context16.prev = 0;
          _context16.next = 3;
          return logOutService();
        case 3:
          _context16.next = 8;
          break;
        case 5:
          _context16.prev = 5;
          _context16.t0 = _context16["catch"](0);
          console.warn(_context16.t0);
        case 8:
          cleanLoginStorage();
          if (!(redirectUrl && typeof redirectUrl === 'string')) {
            _context16.next = 12;
            break;
          }
          // window.location.replace(redirectUrl)
          setTimeout(function () {
            window.location.href = redirectUrl;
          }, timeout || 0);
          return _context16.abrupt("return");
        case 12:
          if (redirectUrl !== false) {
            setTimeout(function () {
              goToLogin();
            }, timeout || 0);
          }
        case 13:
        case "end":
          return _context16.stop();
      }
    }, _callee16, null, [[0, 5]]);
  }));
  return _logOut.apply(this, arguments);
}
export function redirectByUrl() {
  if (window.opener) {
    closeIfHasOpener();
  }
  var redirect = getUrlQuery().redirectUrl;
  if (redirect) {
    var decodeUrl = decodeURIComponent(redirect);
    var link = document.createElement('a');
    link.href = decodeUrl;
    if (link.hostname.includes(config.loginDomain)) {
      window.location.replace(decodeUrl);
      return;
    }
  }
  window.location.replace(config.defaultRedirect);
}
export function requestInterceptor(interConfig) {
  var _ref = interConfig || {},
    when = _ref.when,
    setConfig = _ref.setConfig,
    refreshUrl = _ref.refreshUrl,
    rtTimeoutOffset = _ref.rtTimeoutOffset,
    atTimeoutOffset = _ref.atTimeoutOffset;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(reqConfig) {
      var _reqConfig, _reqConfig$headers, _reqConfig2, _reqConfig2$headers;
      var need, customNeedIntercept, login, customConfig, headerToken;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            need = true;
            customNeedIntercept = true;
            if (!when) {
              _context.next = 11;
              break;
            }
            customNeedIntercept = when(reqConfig);
            if (!(Object.prototype.toString.call(customNeedIntercept) === '[object Promise]')) {
              _context.next = 8;
              break;
            }
            _context.next = 7;
            return customNeedIntercept;
          case 7:
            customNeedIntercept = _context.sent;
          case 8:
            need = customNeedIntercept;
            _context.next = 12;
            break;
          case 11:
            need = !isPdf() && !getLoginUrls().includes(reqConfig.url || '');
          case 12:
            if (!need) {
              _context.next = 17;
              break;
            }
            _context.next = 15;
            return checkoutLogin({
              refreshUrl: refreshUrl,
              rtTimeoutOffset: rtTimeoutOffset,
              atTimeoutOffset: atTimeoutOffset
            });
          case 15:
            login = _context.sent;
            if (!login) {
              // 没有登录，取消请求
              // @ts-ignore
              reqConfig.cancelTokenSource && reqConfig.cancelTokenSource.cancel('cancel-request-because-not-login');
            }
          case 17:
            customConfig = {};
            if (setConfig) {
              customConfig = setConfig(reqConfig);
            }
            reqConfig.params = _objectSpread({}, reqConfig.params);
            reqConfig = _objectSpread(_objectSpread({}, reqConfig), customConfig);
            headerToken = (_reqConfig = reqConfig) === null || _reqConfig === void 0 ? void 0 : (_reqConfig$headers = _reqConfig.headers) === null || _reqConfig$headers === void 0 ? void 0 : _reqConfig$headers.Authorization;
            reqConfig.headers.Authorization = (headerToken === null || headerToken === void 0 ? void 0 : headerToken.startsWith('Bearer')) ? headerToken : "Bearer ".concat(((_reqConfig2 = reqConfig) === null || _reqConfig2 === void 0 ? void 0 : (_reqConfig2$headers = _reqConfig2.headers) === null || _reqConfig2$headers === void 0 ? void 0 : _reqConfig2$headers.Authorization) || getAccessToken());
            return _context.abrupt("return", reqConfig);
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x17) {
      return _ref2.apply(this, arguments);
    };
  }();
}
export function setAtDiffTime(date) {
  var diff = +new Date() - +new Date(date);
  setStorage(CODE_LOGIN.AT_DIFF_TIME, String(diff), {
    domain: getCookieDomain(),
    path: '/',
    expires: 365
  });
}
// 根据响应头的date字段，设置本地时间和服务器时间的差值
export function responseFulfilledInterceptor(resConfig) {
  var _ref3 = resConfig || {},
    wr1 = _ref3.whenRefreshFail;
  return function (res) {
    var _res$headers, _res$request, _res$request$config, _res$data;
    if (res === null || res === void 0 ? void 0 : (_res$headers = res.headers) === null || _res$headers === void 0 ? void 0 : _res$headers.date) {
      var _res$headers2;
      setAtDiffTime(res === null || res === void 0 ? void 0 : (_res$headers2 = res.headers) === null || _res$headers2 === void 0 ? void 0 : _res$headers2.date);
    }
    var _ref4 = (res === null || res === void 0 ? void 0 : (_res$request = res.request) === null || _res$request === void 0 ? void 0 : (_res$request$config = _res$request.config) === null || _res$request$config === void 0 ? void 0 : _res$request$config.customHandler) || {},
      wr2 = _ref4.whenRefreshFail;
    var whenRefreshFail = wr2 || wr1;
    if ([ERROR_CODE.REVOKED_TOKEN, ERROR_CODE.REFRESH_FAIL, ERROR_CODE.REFRESH_OVER_FREQ].includes(res === null || res === void 0 ? void 0 : (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.code)) {
      if (whenRefreshFail) {
        whenRefreshFail(res);
      } else {
        whenResponseFulfilledInterceptorRefreshFail(res);
      }
    }
    return Promise.resolve(res);
  };
}
export function responseInterceptor(resConfig) {
  var _ref5 = resConfig || {},
    wf1 = _ref5.whenForbidden,
    wu1 = _ref5.whenUnauthorized,
    wr1 = _ref5.whenRefreshFail,
    refreshUrl = _ref5.refreshUrl;
  return function (err) {
    var _err$response, _err$response$headers, _err$response3, _err$response3$config, _err$response4, _err$response4$data, _err$response5, _err$response5$config;
    if (err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$headers = _err$response.headers) === null || _err$response$headers === void 0 ? void 0 : _err$response$headers.date) {
      var _err$response2, _err$response2$header;
      setAtDiffTime(err === null || err === void 0 ? void 0 : (_err$response2 = err.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$header = _err$response2.headers) === null || _err$response2$header === void 0 ? void 0 : _err$response2$header.date);
    }
    var _ref6 = (err === null || err === void 0 ? void 0 : (_err$response3 = err.response) === null || _err$response3 === void 0 ? void 0 : (_err$response3$config = _err$response3.config) === null || _err$response3$config === void 0 ? void 0 : _err$response3$config.customHandler) || {},
      wf2 = _ref6.whenForbidden,
      wu2 = _ref6.whenUnauthorized,
      wr2 = _ref6.whenRefreshFail;
    var whenForbidden = wf2 || wf1;
    var whenUnauthorized = wu2 || wu1;
    var whenRefreshFail = wr2 || wr1;
    if ([ERROR_CODE.REVOKED_TOKEN, ERROR_CODE.REFRESH_FAIL, ERROR_CODE.REFRESH_OVER_FREQ].includes(err === null || err === void 0 ? void 0 : (_err$response4 = err.response) === null || _err$response4 === void 0 ? void 0 : (_err$response4$data = _err$response4.data) === null || _err$response4$data === void 0 ? void 0 : _err$response4$data.code)) {
      if (whenRefreshFail) {
        whenRefreshFail(err);
      } else {
        goToLogin();
      }
    } else if (!(err === null || err === void 0 ? void 0 : (_err$response5 = err.response) === null || _err$response5 === void 0 ? void 0 : (_err$response5$config = _err$response5.config) === null || _err$response5$config === void 0 ? void 0 : _err$response5$config.customErr) && (err === null || err === void 0 ? void 0 : err.message) !== 'cancel-request-because-not-login') {
      var _err$response6;
      var resStatus = err === null || err === void 0 ? void 0 : (_err$response6 = err.response) === null || _err$response6 === void 0 ? void 0 : _err$response6.status;
      if (resStatus === 401) {
        var _err$response7, _err$response7$config;
        if (whenUnauthorized) {
          whenUnauthorized(err);
        } else if ((err === null || err === void 0 ? void 0 : (_err$response7 = err.response) === null || _err$response7 === void 0 ? void 0 : (_err$response7$config = _err$response7.config) === null || _err$response7$config === void 0 ? void 0 : _err$response7$config.url) !== '/metis-atlas-account/api/auth/phone-login') {
          checkoutLogin({
            refreshUrl: refreshUrl
          });
        }
      } else if (resStatus === 403) {
        if (whenForbidden) {
          whenForbidden(err);
        } else {
          var _err$response8, _err$response8$config, _err$response9, _err$response9$data;
          if (err === null || err === void 0 ? void 0 : (_err$response8 = err.response) === null || _err$response8 === void 0 ? void 0 : (_err$response8$config = _err$response8.config) === null || _err$response8$config === void 0 ? void 0 : _err$response8$config.url.includes('/verifier/api/sms')) {
            err.response.data.code = ERROR_CODE.REFRESH_OVER_FREQ;
            return Promise.reject(err);
          }
          if ([ERROR_CODE.NO_PERMISSION, ERROR_CODE.NO_PERMISSION2].includes(err === null || err === void 0 ? void 0 : (_err$response9 = err.response) === null || _err$response9 === void 0 ? void 0 : (_err$response9$data = _err$response9.data) === null || _err$response9$data === void 0 ? void 0 : _err$response9$data.code)) {
            goNoPermission();
          }
        }
      }
    }
    return Promise.reject(err);
  };
}
var autoRefreshTimer = 0;
export function autoRefreshToken(autoRefreshConfig) {
  var _ref7 = autoRefreshConfig || {},
    _ref7$jumpLogin = _ref7.jumpLogin,
    jumpLogin = _ref7$jumpLogin === void 0 ? true : _ref7$jumpLogin,
    _ref7$interval = _ref7.interval,
    interval = _ref7$interval === void 0 ? 3000 : _ref7$interval,
    refreshUrl = _ref7.refreshUrl;
  clearInterval(autoRefreshTimer);
  autoRefreshTimer = window.setInterval(function () {
    checkoutLogin({
      jumpLogin: jumpLogin,
      refreshUrl: refreshUrl
    });
  }, interval);
}
export function closeAutoRefreshToken() {
  clearInterval(autoRefreshTimer);
}
/**
 * 解锁学生账号｜当前机构
 * @param params { studentIds?: number[], year: number }
 */
export function handleUnlockStudentAccount(_x18) {
  return _handleUnlockStudentAccount.apply(this, arguments);
}
function _handleUnlockStudentAccount() {
  _handleUnlockStudentAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(params) {
    var res;
    return _regeneratorRuntime().wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          _context17.prev = 0;
          _context17.next = 3;
          return unlockStudentAccount(params);
        case 3:
          res = _context17.sent;
          return _context17.abrupt("return", res);
        case 7:
          _context17.prev = 7;
          _context17.t0 = _context17["catch"](0);
          console.warn(_context17.t0);
          return _context17.abrupt("return", Promise.reject(_context17.t0));
        case 11:
        case "end":
          return _context17.stop();
      }
    }, _callee17, null, [[0, 7]]);
  }));
  return _handleUnlockStudentAccount.apply(this, arguments);
}